import { useState, useEffect } from 'react';
import { useMenu } from 'context/MenuContext';
import { getTileProposals } from 'services/tileService';

export const usePendingProposals = (isAdmin) => {
    const { setPendingProposals } = useMenu();
    const [isLoading, setIsLoading] = useState(false);

    const fetchPendingProposals = async () => {
        if (!isAdmin) {
            setPendingProposals(0);
            return;
        }

        setIsLoading(true);
        try {
            const response = await getTileProposals();
            const data = response.data;
            const pendingCount = data.filter(
                proposal => !proposal.PRP_VALIDATED_AT && !proposal.PRP_DECLINED_AT
            ).length;
            setPendingProposals(pendingCount);
        } catch (error) {
            console.error('Erreur lors de la récupération des propositions:', error);
            setPendingProposals(0);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        // Récupérer immédiatement
        fetchPendingProposals();

        // Puis toutes les 2 minutes (plus raisonnable que 30 secondes)
        const interval = setInterval(fetchPendingProposals, 2 * 60 * 1000);

        return () => clearInterval(interval);
    }, [isAdmin]);

    return { isLoading, refetch: fetchPendingProposals };
};
